function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import _merge from 'lodash/merge';
import _get from 'lodash/get';
import { Typography } from "../Typography/index.js";
import { TYPOGRAPHY_VARIANT } from "../../theme/typography.theme/index.js";
import { COLOR_VARIANTS } from "../../theme/palette.theme/index.js";
import { color } from "../../utils/index.js"; // Update the Button's color prop options
export var APPEARANCES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DARK: 'dark',
  GHOST: 'ghost',
  REVERSED: 'reversed',
  DESTRUCTIVE: 'destructive',
  DESTRUCTIVE_GHOST: 'destructive_ghost',
  DESTRUCTIVE_REVERSED: 'destructive_reversed',
  PAYMENT: 'payment',
  ICON: 'icon'
};
export var SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium'
};
function getAppearanceDef(appearance) {
  var appearancesDef = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, APPEARANCES.PRIMARY, {
    variant: 'contained',
    color: COLOR_VARIANTS.CORAL100,
    styles: {
      color: COLOR_VARIANTS.WHITE,
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      }
    }
  }), APPEARANCES.SECONDARY, {
    variant: 'contained',
    color: COLOR_VARIANTS.AQUA100,
    styles: {
      color: COLOR_VARIANTS.WHITE
    }
  }), APPEARANCES.DARK, {
    variant: 'contained',
    color: COLOR_VARIANTS.DARKTEAL,
    styles: {
      color: COLOR_VARIANTS.WHITE
    }
  }), APPEARANCES.GHOST, {
    variant: 'outlined',
    color: COLOR_VARIANTS.AQUA100,
    styles: {
      color: color(COLOR_VARIANTS.AQUA100),
      border: "1px solid ".concat(color(COLOR_VARIANTS.AQUA100)),
      background: 'transparent',
      '&:hover': {
        background: color(COLOR_VARIANTS.AQUA10)
      },
      '&:active': {
        border: "1px solid ".concat(color(COLOR_VARIANTS.AQUA100)),
        background: color(COLOR_VARIANTS.GHOSTWHITE)
      }
    }
  }), APPEARANCES.REVERSED, {
    variant: 'contained',
    color: COLOR_VARIANTS.WHITE,
    styles: {
      color: COLOR_VARIANTS.AQUA100,
      boxShadow: 'none'
    }
  }), APPEARANCES.DESTRUCTIVE, {
    variant: 'contained',
    color: COLOR_VARIANTS.WHITE,
    styles: {
      color: color(COLOR_VARIANTS.CRIMSON100),
      '&:hover': {
        background: color(COLOR_VARIANTS.CRIMSON5)
      }
    }
  }), APPEARANCES.DESTRUCTIVE_GHOST, {
    variant: 'contained',
    color: COLOR_VARIANTS.WHITE,
    styles: {
      color: color(COLOR_VARIANTS.CRIMSON100),
      border: "1px solid ".concat(color(COLOR_VARIANTS.CRIMSON100)),
      '&:hover': {
        background: color(COLOR_VARIANTS.CORAL10)
      }
    }
  }), APPEARANCES.DESTRUCTIVE_REVERSED, {
    variant: 'contained',
    color: COLOR_VARIANTS.WHITE,
    styles: {
      color: color(COLOR_VARIANTS.CRIMSON100),
      '&:hover': {
        background: color(COLOR_VARIANTS.CORAL10)
      }
    }
  }), APPEARANCES.PAYMENT, {
    variant: 'contained',
    color: COLOR_VARIANTS.FOREST100,
    styles: {
      color: COLOR_VARIANTS.WHITE
    }
  }), APPEARANCES.ICON, {
    variant: 'contained',
    color: COLOR_VARIANTS.CORAL100,
    styles: {
      color: COLOR_VARIANTS.WHITE
    }
  });
  return appearancesDef[appearance] || appearancesDef[APPEARANCES.PRIMARY];
}
export var Button = function Button(_ref) {
  var appearance = _ref.appearance,
    children = _ref.children,
    size = _ref.size,
    isDisabled = _ref.isDisabled,
    fullWidth = _ref.fullWidth,
    startIcon = _ref.startIcon,
    endIcon = _ref.endIcon,
    onClick = _ref.onClick,
    href = _ref.href,
    target = _ref.target,
    testId = _ref.testId,
    isLoading = _ref.isLoading,
    loadingPosition = _ref.loadingPosition,
    loadingIndicator = _ref.loadingIndicator,
    type = _ref.type,
    borderRadius = _ref.borderRadius,
    className = _ref.className,
    sx = _ref.sx;
  var appearanceDef = getAppearanceDef(appearance);
  var targetAttr = {
    target: target
  };
  return /*#__PURE__*/React.createElement(LoadingButton, _extends({
    className: "__ds__comp ".concat(className),
    variant: appearanceDef.variant,
    disableRipple: true,
    size: size,
    disabled: isDisabled,
    color: appearanceDef.color,
    startIcon: startIcon || null,
    endIcon: endIcon || null,
    onClick: onClick,
    type: type || 'button',
    href: href
  }, targetAttr, {
    sx: _merge({
      borderRadius: borderRadius || '100px',
      width: fullWidth ? '100%' : 'auto',
      padding: size === SIZES.SMALL ? '10px 16px' : '12px 24px',
      transition: '0.2s all',
      '& .MuiLoadingButton-loading': {
        color: 'transparent'
      },
      '& .MuiLoadingButton-loadingIndicator': {
        left: loadingPosition === 'start' ? '24px' : 'none',
        right: loadingPosition === 'end' ? '24px' : 'none'
      },
      '&:active': {
        transform: 'scale(0.97)'
      }
    }, appearanceDef.styles, sx),
    "data-testid": testId,
    loading: isLoading,
    loadingIndicator: loadingIndicator,
    loadingPosition: loadingPosition
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: size === SIZES.SMALL ? TYPOGRAPHY_VARIANT.HEADING4SEMBLD : TYPOGRAPHY_VARIANT.HEADING3SEMBLD,
    component: "span"
    // color={COLOR_VARIANTS.MINESHAFT}
    ,
    color: _get(appearanceDef, 'styles.color', ''),
    sx: {
      color: isLoading && loadingPosition === 'center' ? 'transparent' : ''
    }
  }, children));
};